import { POST } from "../APiHelper/API"

export const applyWyScoutBenchAPI = (data, onSuccess, onError) => {

    // const data = {
    //     fixture_id: fixture_id,
    //     team_id: team_id,
    // }

    POST(`/api/v1/squads/apply_wyscout_bench`, data, onSuccess, onError)
}